/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { animated, useTransition } from '@react-spring/web';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './blackout.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface BlackoutProps {
    /**
     * Whether the blackout component is visible or not
     */
    isOpen: boolean;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledBlackout = styled(animated.div).withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Blackout: FunctionComponent<BlackoutProps> = ({
    isOpen,
    ...otherProps
}: BlackoutProps) => {
    const transitions = useTransition(isOpen, {
        from: {
            opacity: 0,
        },
        enter: {
            opacity: 1,
        },
        leave: {
            opacity: 0,
        },
    });

    return (
        <React.Fragment>
            {transitions((props, item) =>
                item ? (
                    <StyledBlackout
                        isOpen={isOpen}
                        {...otherProps}
                        style={props}
                    />
                ) : null
            )}
        </React.Fragment>
    );
};
